import { createBundle } from 'widget/Common';
import ChatListView from 'bundle-loader?lazy&name=ChatListView!pages/TIM/ChatList/ChatListView';
import ChatView from 'bundle-loader?lazy&name=ChatView!pages/TIM/Chat/ChatView';

const RouterConfig = [
  {
    path: '/tim/ChatList',
    title: '我的消息',
    component: () => {
      return createBundle(ChatListView);
    }
  },
  {
    path: '/TIM/Chat',
    title: '',
    component: () => {
      return createBundle(ChatView);
    }
  }
];

export default RouterConfig;



// WEBPACK FOOTER //
// ./src/pages/TIM/RouterConfig.js